import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "tailwind-variants";

import { GuaranteeNoticeModal } from "@/components/Modals/GuaranteeNoticeModal/guaranteeNoticeModal";
import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { useModalRouter } from "@/utils/hooks/useModalRouter";

const Label = () => {
    const { t } = useGranite();

    const { open: openModal } = useModalRouter(ModalType.GuaranteeNotice);

    const handleOnClick = () => {
        openModal();
    };

    return (
        <>
            <Button
                color={"link"}
                className={cn("tw:text-sm! tw:p-0 tw:font-light tw:m-0")}
                onClick={handleOnClick}
            >
                {t("product.guaranteeNotice.label")}
            </Button>
            <GuaranteeNoticeModal />
        </>
    );
};

export { Label };
